import { useMemo } from 'react';

import { TEAM_LIST } from '@/utils/constants';

const useGetClubColorById = (clubId: number | undefined) => {
  return useMemo(() => {
    const club = TEAM_LIST.find((team) => team.value === clubId);
    return (
      club?.colors ?? {
        primary: '#FFF',
        secondary: '#FFF',
      }
    );
  }, [clubId]);
};

export default useGetClubColorById;
